import { useState, type ReactNode, useMemo } from "react";

import { type TreeDescriptor } from "@/components/treeModule/lib";

import { MultiStemCircumferenceDialog } from "./MultiStemCircumferenceDialog";
import { SingleStemCircumferenceDialog } from "./SingleStemCircumferenceDialog";
import { MultiStemDiameterDialog } from "./MultiStemDiameterDialog";
import { SingleStemDiameterDialog } from "./SingleStemDiameterDialog";

import {
  TreePropertyType,
  type TrunkTypeTreePropertyDescriptor,
} from "@/components/treeModule/lib";

export interface TreeMeasurementsDialogContainerProps {
  children: (setOpen: (open: boolean) => void) => ReactNode;
  treeDescriptor: TreeDescriptor | undefined | null;
}

export function TreeMeasurementsDialogContainer({
  children,
  treeDescriptor,
}: TreeMeasurementsDialogContainerProps) {
  const [open, setOpen] = useState(false);

  const circumferencePropertyExists = treeDescriptor?.properties.has(
    TreePropertyType.circumference,
  );

  const trunkType = treeDescriptor?.properties.get(TreePropertyType.trunk_type);

  const renderDialog = () => {
    const isMultiStem = trunkType?.value === "multi";
    if (!isMultiStem && circumferencePropertyExists) {
      return (
        <SingleStemCircumferenceDialog
          onOpenChange={setOpen}
          open={open}
          treeDescriptor={treeDescriptor}
        />
      );
    }
    if (isMultiStem && circumferencePropertyExists) {
      return (
        <MultiStemCircumferenceDialog
          onOpenChange={setOpen}
          open={open}
          treeDescriptor={treeDescriptor}
        />
      );
    }
    if (!isMultiStem && !circumferencePropertyExists) {
      return (
        <SingleStemDiameterDialog
          onOpenChange={setOpen}
          open={open}
          treeDescriptor={treeDescriptor}
        />
      );
    }
    if (isMultiStem && !circumferencePropertyExists) {
      return (
        <MultiStemDiameterDialog
          onOpenChange={setOpen}
          open={open}
          treeDescriptor={treeDescriptor}
        />
      );
    }
  };

  return (
    <>
      {children(setOpen)}

      {renderDialog()}
    </>
  );
}
